import { render, staticRenderFns } from "./SignIn.vue?vue&type=template&id=20b8557e&scoped=true&"
import script from "./SignIn.vue?vue&type=script&lang=ts&"
export * from "./SignIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8557e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b8557e')) {
      api.createRecord('20b8557e', component.options)
    } else {
      api.reload('20b8557e', component.options)
    }
    module.hot.accept("./SignIn.vue?vue&type=template&id=20b8557e&scoped=true&", function () {
      api.rerender('20b8557e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/auth/SignIn.vue"
export default component.exports